export default __webpack_public_path__ + "static/media/example_api.f4844634.PNG";